module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/path.js
// module id = 238
// module chunks = 0